// extracted by mini-css-extract-plugin
export default {"main":"styles_main__0B6sD","title":"styles_title__fBRYH","select":"styles_select__21Ibp","btn":"styles_btn__ChAVf"};